export default {
  app: {
    privacy: {
      policy: 'Privaatsuspoliitika',
      expansive: 'Kasutades Expansive, nõustute Expansive {action} tingimustega',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Sessioon aegus',
    sessionExpiredDescription: 'Teie sessioon on aegunud. Jätkamiseks logige uuesti sisse.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Vali keel',
      chooseLanguageDescription:
        'Valige rakenduse jaoks eelistatud keel. See muudab liidese ja sisu keelt.',
    },
    userSelection: {
      cancel: 'Tühista',
      createNewUser: 'Nende nime pole loendis',
      newUser: 'Uus kasutaja',
      selectAnExistingUser: 'Vali olemasolev kasutaja',
      selectUserHint: 'Jätkamiseks vali olemasolev kasutaja või loo uus.',
      startTypingToSearch: 'Alusta kirjutamist...',
    },
    verification: {
      codeVerification: {
        continue: 'Jätka',
        header: 'Sisesta objekti pääsukood',
        invalidCode: 'Vigane kood, proovi uuesti.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Jätka asukohta kinnitamata',
        enterSiteAccessCode: 'Sisesta objekti pääsukood',
        locationNotEnabledOrAvailable: 'Miks ma seda näen?',
        notAvailable: {
          description: 'GPS asukoht ei ole selle seadme jaoks toetatud.',
          header: 'Asukoht pole toetatud',
        },
        notEnabled: {
          description: 'Asukohateenused pole lubatud või õigust pole antud.',
          header: 'Asukoht pole lubatud',
        },
        notVerified: {
          description: 'GPS näitab, et te ei ole objektil.',
          header: 'Asukoht pole kinnitatud',
        },
        tryAgain: 'Proovi uuesti',
        unavailable: {
          description: 'Me ei saanud teie GPS asukohta kinnitada.',
          header: 'Asukoht pole saadaval',
        },
        unknown: {
          description: 'Me ei suuda teie asukohta määrata.',
          header: 'Asukoht teadmata',
        },
        verified: {
          description: 'GPS näitab, et olete objektil.',
          header: 'Asukoht kinnitatud',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Varasid ei leitud',
        emptyDescription: 'Selle töökorraldusega pole seotud varasid.',
        warrantyParts: 'Varuosade garantii lõpeb',
        serialNumber: 'Seerianumber',
        none: '<puudub>',
      },
      updates: {
        emptyTitle: 'Uuendusi ei leitud',
        emptyDescription: 'Selle töökorralduse kohta pole uuendusi.',
        unknownUser: 'Tundmatu kasutaja',
        none: 'Puudub',
        addComment: {
          buttonLabel: 'Lisa kommentaar',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Ohud',
          no: 'Ei',
          yes: 'Jah',
        },
      },
    },
    attachmentsList: {
      attachments: 'Manused',
      documents: 'Dokumendid',
      siteDocuments: 'Objekti dokumendid',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Ohud',
        induction: 'Tööohutusjuhend',
        safeToProceed: 'Ohutu jätkata',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Tähtaeg',
        activeSessions: 'Aktiivsed sessioonid',
        activeSessionsDescription:
          'Olete juba sisse registreeritud järgmistele töökorraldustele. Enne uue töökorraldusega liitumist peate neist väljuma.',
        resumeSession: 'Jätka',
        startTime: 'Alustati',
        unexpectedErrorTitle: 'Ootamatu viga',
        unexpectedErrorMessage:
          'Sessioonide loomisel tekkis ootamatu viga. Palun proovige hiljem uuesti.',
        engineerNotFound: 'Inseneri ei leitud',
        engineerNotFoundDescription:
          'Inseneri, keda proovite registreerida, ei leitud süsteemist. Võtke ühendust administraatoriga.',
      },
      verification: {
        code: {
          description:
            'Sisseregistreerimiseks küsige 4-kohaline kood objekti juhilt või kontaktisikult.',
        },
        geo: {
          continue: 'Jätka',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Palun hankige juurdepääsukood saidihaldurilt või määratud kontaktilt külastuse lõpetamiseks.',
            checkOut: 'Välju',
            completeBeforeLeaving: 'Palun täitke enne lahkumist järgmine vorm.',
            continue: 'Jätka',
            noResolutionSelected: 'Jätkamiseks valige lahendus.',
            quoteRequired: {
              hint: 'Külastus lõpetatud, pakkumine järgneb',
              label: 'Pakkumine vajalik',
            },
            returnVisitRequired: {
              hint: 'Tuleme tagasi töö lõpetamiseks',
              label: 'Tagasikülastus vajalik',
            },
            serviceCompleted: {
              hint: 'Edasisi toiminguid pole vaja',
              label: 'Töö lõpetatud',
            },
            uploadCheckout: 'Laadi üles fail, foto või video',
            visitNotes: 'Külastuse märkmed',
            workOrderResolution: 'Töökorralduse lahendus',
            enterNotes: 'Sisesta märkmed siia...',
            errors: {
              timedOut: 'Aeg sai otsa, ületati 30 sekundit. Palun proovi uuesti.',
              closingSession: 'Viga sessiooni sulgemisel',
            },
          },
          success: {
            description:
              'Täname külastuse eest {site}. | {site}l on veel 1 avatud töökorraldus. | {site}l on veel {count} avatud töökorraldust.',
            endVisit: 'Lõpeta külastus',
            header: 'Olete edukalt välja registreeritud',
            viewWorkOrders: 'Registreeru teisele töökorraldusele',
          },
          verification: {
            code: {
              description:
                'Välja registreerimiseks küsige 4-kohaline kood objekti juhilt või kontaktisikult.',
              continue: 'Jätka',
            },
            geo: {
              checkOut: 'Välju',
              continue: 'Jätka',
            },
          },
        },
        detail: {
          assets: 'Varad',
          call: 'Helista',
          checkOut: 'Välju',
          closed: 'Suletud',
          details: 'Detailid',
          dueBy: 'Tähtaeg',
          manageEngineers: 'Halda insenere',
          notAvailable: 'Pole saadaval',
          pointOfContact: 'Kontaktisik',
          siteAccessTimes: 'Objekti ligipääsuajad',
          siteAccessInstructions: 'Ligipääsu juhised',
          siteAddress: 'Objekti aadress',
          siteNotes: 'Objekti märkmed',
          siteTelephone: 'Objekti telefon',
          siteLocation: 'Objekti asukoht',
          updates: 'Uuendused',
          more: 'Rohkem',
          mismatchErrorTitle: 'Töökorralduse viga',
          mismatchErrorMessage:
            'Töökorraldus, millele proovite ligi pääseda, ei ühti sellega, kuhu olete registreeritud. Palun kontrollige töökorraldust ja proovige uuesti.',
          siteDocuments: 'Objekti dokumendid',
          validFrom: 'Kehtiv alates',
          validUntil: 'Kehtiv kuni',
          documentName: 'Dokumendi nimi',
          documentType: 'Dokumendi tüüp',
          attachments: 'Töökorralduse failid',
          download: 'Laadi alla',
          workDetails: 'Töö detailid',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Lisa abiinsener',
            assistantEngineers: 'Abiinsenerid',
            description: 'Turvalisuse huvides märkige kõik objektil viibivad insenerid.',
            editMainEngineer: 'Muuda peainseneri',
            errors: {
              creatingEngineer: 'Viga inseneri loomisel',
              creatingSession: 'Viga sessiooni loomisel',
            },
            header: 'Insenerid objektil',
            mainEngineer: 'Peainsener',
            newAssistantEngineer: 'Sisesta tema täisnimi',
            next: 'Järgmine',
            removeEngineer: 'Eemalda insener',
            selectExistingAssistantEngineer: 'Alusta tema nime kirjutamist',
          },
          index: {
            description: 'Turvalisuse huvides märkige kõik objektil viibivad insenerid.',
            errorCreatingEngineer: 'Viga inseneri loomisel, proovige uuesti.',
            header: 'Insenerid objektil',
            hintMainEngineer: 'Sisesta peainseneri täisnimi',
            newMainEngineer: 'Uus peainsener',
            next: 'Järgmine',
            selectExistingMainEngineer: 'Vali olemasolev peainsener',
            yes: 'Jah',
            no: 'Ei',
            mainEngineerLabel: 'Kas olete peainsener?',
          },
        },
        index: {
          callUsOn: 'Helista numbril {phoneNumber}',
          description: 'Ei leia, mida otsid?',
          dueBy: 'Tähtaeg',
          header: 'Vali töökorraldus',
          notAvailable: 'Pole saadaval',
          searchWorkOrders: 'Otsi töökorraldusi...',
        },
        manageEngineers: {
          manageEngineers: 'Halda insenere',
          notWorking: 'Mitteaktiivsed töötajad',
          pause: 'Paus',
          resume: 'Jätka',
          workingNow: 'Aktiivsed töötajad',
          startTime: 'Algusaeg',
          endTime: 'Lõpuaeg',
          duration: 'Kestus',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Tagasiside',
            feedbackDescription:
              'Palun andke töökorralduse kohta tagasisidet, et saaksime oma teenuseid parandada.',
            feedbackLabel: 'Tagasiside',
            filesLabel: 'Manused',
            submissionLabel: 'Esita tagasiside',
          },
          hazards: {
            back: 'Tagasi',
            hazards: 'Ohud',
            next: 'Järgmine',
            no: 'Ei',
            noTasksForHazard: 'Selle ohu jaoks pole ülesandeid.',
            yes: 'Jah',
          },
          induction: {
            continue: 'Jätka',
            induction: 'Tööohutusjuhend',
          },
          index: {
            checkIn: 'Registreeru',
            description: 'Palun täitke valitud töö jaoks järgmine riskihindamine.',
            fail: 'Töö alustamise kontrollide töötlemine ebaõnnestus.',
            haltMessage:
              'Tuvastati potentsiaalsed riskid. Palun peatage töö, vaadake üle ohutusjuhised ja võtke ühendust juhendajaga.',
            header: 'Töö alustamise kontrollid',
            endVisit: 'Lõpeta külastus',
            leaveFeedback: 'Anna tagasisidet',
          },
          safeToProceed: {
            continue: 'Jätka',
            safeToProceed: 'Ohutu jätkata',
          },
        },
      },
    },
    index: {
      title: 'Tere tulemast',
      description: 'Alustamiseks skaneeri oma asukohas QR-kood.',
    },
    login: {
      errorTitle: 'Ootamatu viga',
      errorMessage: 'Tekkis ootamatu viga. Palun proovi QR-koodi uuesti skaneerida.',
    },
    unauthenticated: {
      welcome: {
        title: 'Tere tulemast {site}',
        description:
          'Enne kui saame teile töökorraldusi näidata, peame teie andmed kinnitama. Jätkamiseks klõpsake alloleval nupul.',
        next: 'Jätka',
      },
      index: {
        errorTitle: 'Ootamatu viga',
        errorMessage: 'Tekkis ootamatu viga. Palun proovi QR-koodi uuesti skaneerida.',
      },
      contractor: {
        title: 'Kelle heaks töötate?',
        contractor: 'Töövõtja',
        contractorLabel: 'Alusta oma ettevõtte nime kirjutamist',
        contractorHint: 'Tulemuste nägemiseks sisesta vähemalt 3 tähemärki',
        defaultSelectPlaceholder: '--Palun vali--',
        next: 'Järgmine',
      },
      user: {
        title: 'Kes sa oled?',
        cancel: 'Tühista',
        createNewUserLabel: 'Minu nime pole loendis',
        existingUserLabel: 'Alusta oma nime kirjutamist',
        existingUserHint: 'Tulemuste nägemiseks sisesta vähemalt 3 tähemärki',
        newUserLabel: 'Sisesta oma täisnimi',
        next: 'Järgmine',
        user: 'Kasutaja',
      },
      verification: {
        methods: {
          add: {
            add: 'Lisa kinnitamise meetod',
            defaultSelectPlaceholder: '--Palun vali--',
            emailLabel: 'E-post',
            existingMethodWarning:
              'Teil on juba selle kinnitamise meetodi jaoks ootel taotlus, mis ootab administraatori kinnitust. Uue lisamine asendab selle.',
            method: 'Meetod',
            methodLabel: 'Meetod',
            mobileCountryHint: 'Palun vali riigi kood',
            mobileCountryLabel: 'Mobiili riigi kood',
            mobileHint: 'Palun sisesta oma mobiiltelefon',
            mobileLabel: 'Mobiil',
            title: 'Lisa kinnitamise meetod',
          },
          confirm: {
            confirm: 'Kinnita',
            description: 'Jätkamiseks kinnitage oma kinnitamise meetod.',
            label: 'Sisesta oma kood',
            resend: 'Saada uuesti',
            resendPrompt: 'Ei saanud koodi?',
            title: 'Kinnita kinnitamise meetod',
          },
          confirmed: {
            description:
              'Teid teavitatakse, kui see kinnitamise meetod on administraatori poolt kinnitatud ja saate seda kasutada oma isiku tuvastamiseks.',
            forceApproval: 'Kuni see on kinnitatud, ei saa te töökorraldustele ligi.',
            nonForceApproval: 'Seniks saate töökorraldustele ligi piiratud ligipääsuga.',
            nonForceApprovalButtonLabel: 'Jätka piiratud ligipääsuga',
            title: 'Ootel kinnitust',
          },
          addNew: 'Lisa uus kinnitamise meetod',
          description:
            'Peame teie isikut kinnitama, et anda teile täielik ligipääs töökorraldusele.',
          email: 'E-post',
          hint: 'Saadame lingi teie valitud kinnitamise meetodile, mis annab teile täieliku ligipääsu töökorraldusele. Kui peate muutma olemasolevaid kinnitamise meetodeid, võtke ühendust administraatoriga.',
          label: 'Vali kinnitamise meetod',
          next: 'Järgmine',
          pendingHint: 'Ootab administraatori kinnitust',
          sms: 'SMS',
          title: 'Kinnitamine',
        },
        optional: {
          hint: 'Kasutaja andmete kinnitamine annab teile täieliku ligipääsu töökorraldusele',
          label: 'Kas soovite oma andmeid kinnitada?',
          next: 'Järgmine',
          no: 'Ei',
          noHint:
            'Ma ei soovi oma andmeid kinnitada ja jätkan töökorraldusele piiratud ligipääsuga',
          title: 'Kinnitamine',
          yes: 'Jah',
          yesHint: 'Soovin oma andmeid kinnitada ja saada täielik ligipääs töökorraldusele',
        },
        sent: {
          description:
            'Sisselogimislink saadeti aadressile {identifier}. Palun klõpsake lingil, et lõpetada sisselogimine.',
          title: 'Sisselogimislink saadetud',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Eile',
      today: 'Täna',
      days: {
        monday: 'Esmaspäev',
        tuesday: 'Teisipäev',
        wednesday: 'Kolmapäev',
        thursday: 'Neljapäev',
        friday: 'Reede',
        saturday: 'Laupäev',
        sunday: 'Pühapäev',
      },
      months: {
        january: 'Jaanuar',
        february: 'Veebruar',
        march: 'Märts',
        april: 'Aprill',
        may: 'Mai',
        june: 'Juuni',
        july: 'Juuli',
        august: 'August',
        september: 'September',
        october: 'Oktoober',
        november: 'November',
        december: 'Detsember',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Midagi läks valesti',
      message: 'Palun proovi QR-koodi uuesti skaneerida.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Tundmatu kasutaja',
      },
      none: 'Puudub',
      types: {
        stateTransition: 'Olek muutus',
        contractorAssigned: 'Töövõtja määratud',
        engineerAssigned: 'Insener määratud',
        serviceAssigned: 'Teenusepakkuja määratud',
        priorityChanged: 'Tähtsus muutus',
        actionableDateChanged: 'Teostatavuse kuupäev muutus',
        dueDateChanged: 'Tähtaeg muutus',
        etaDateChanged: 'Eeldatav saabumisaeg muutus',
        spendLimitApproved: 'Kulu limiit kinnitatud',
        spendLimitCancelled: 'Kulu limiidi taotlus tühistatud',
        spendLimitRejected: 'Kulu limiit tagasi lükatud',
        spendLimitRequested: 'Kulu limiit taotletud',
        jobSheetUploaded: 'Tööleht üles laaditud',
        slaAlertSent: 'SLA rikkumise teavitus',
        issuedWorkPermit: 'Tööloa väljastamine',
        requestForServiceSent: 'Teenuse taotlus saadetud',
        comment: 'Kommentaar lisatud',
        unknown: 'Tundmatu sündmus',
      },
      labels: {
        actionableDate: 'Teostatavuse kuupäev',
        comment: 'Kommentaar',
        file: 'Fail',
        contractor: 'Töövõtja',
        dueDate: 'Tähtaeg',
        etaDate: 'Eeldatav saabumisaeg',
        engineer: 'Insener',
        priority: 'Tähtsus',
        requestForService: 'Teenuse taotlus',
        service: 'Teenusepakkuja',
        spendLimit: 'Kulu limiit',
        status: 'Olek',
        workPermit: 'Töö luba',
      },
    },
  },
}
